import styles from "./BottomButtonBox.module.css";
import MiniButton, { ButtonProps } from "./MiniButton";

/**
 * 사이드시트 하단 버튼 박스 설정
 * @interface
 * @prop left (optional) {@link ButtonProps} 좌측 버튼 설정
 * @prop right {@link ButtonProps} 우측 버튼 설정
 */
export interface ButtomButtonBoxProps {
    left?: ButtonProps;
    right?: ButtonProps;
    isMobileView?: boolean;
}

/**
 * 사이드 시트, 플로팅 사이드 시트에서 사용하는 하단 버튼 박스 공통 컴포넌트
 *
 * @author mjkang
 * @since 2024-09-11 10:25:30
 * @param prop {@link ButtomButtonBoxProps}
 * @returns BottomButtonBox
 */
const BottomButtonBox = (prop: ButtomButtonBoxProps) => {
    // const { left, right, isMobileView } = prop;
    const { left, right } = prop;

    return (
        // <div className={styles.wrapper}>
        //     {!isMobileView && <div className={styles.left}>
        //         {left && <MiniButton {...left} />}
        //     </div>}
        //     {(!isMobileView || right?.label === "이전") && right && (
        //         <div className={styles.right}>
        //             <MiniButton {...right} />
        //         </div>
        //     )}
        // </div>
        // 모바일일때도 PC랑 동일하게 버튼 표출 | smyun | 250905
        <div className={styles.wrapper}>
            {<div className={styles.left}>{left && <MiniButton {...left} />}</div>}
            {right && (
                <div className={styles.right}>
                    <MiniButton {...right} />
                </div>
            )}
        </div>
    );
};

export default BottomButtonBox;
